import DOMPurify from 'dompurify';

// Configure DOMPurify to allow safe HTML elements
const ALLOWED_TAGS = [
  'p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'strike',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'ul', 'ol', 'li',
  'blockquote', 'pre', 'code',
  'a', 'img',
  'table', 'thead', 'tbody', 'tr', 'th', 'td',
  'span', 'div', 'sub', 'sup'
];

const ALLOWED_ATTR = [
  'href', 'target', 'rel',
  'src', 'alt', 'width', 'height', 'style', 'class',
  'colspan', 'rowspan'
];

/**
 * Sanitize HTML content to prevent XSS attacks
 * @param {string} html - Raw HTML string
 * @returns {string} - Sanitized HTML string
 */
export function sanitizeHTML(html) {
  if (!html) return '';
  
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    ADD_ATTR: ['target'],
    FORBID_TAGS: ['script', 'style', 'iframe', 'form', 'input', 'button'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover']
  });
}

/**
 * Sanitize and strip HTML tags for plain text preview
 * @param {string} html - Raw HTML string
 * @returns {string} - Plain text without HTML tags
 */
export function stripHTML(html) {
  if (!html) return '';
  const clean = DOMPurify.sanitize(html, { ALLOWED_TAGS: [] });
  return clean.replace(/&nbsp;/g, ' ').trim();
}

/**
 * Sanitize HTML for question text (allows images)
 * @param {string} html - Raw HTML string  
 * @returns {string} - Sanitized HTML
 */
export function sanitizeQuestionHTML(html) {
  if (!html) return '';
  
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [...ALLOWED_TAGS, 'figure', 'figcaption'],
    ALLOWED_ATTR: [...ALLOWED_ATTR, 'data-align'],
    ADD_ATTR: ['target'],
  });
}

export default { sanitizeHTML, stripHTML, sanitizeQuestionHTML };
